import { skillGroups } from "../data";
import { Reveal, Section } from "./ui";

export function Skills() {
  return (
    <Section
      id="toolkit"
      title="Toolkit"
      intro="What I reach for, and how well I know it. I'd rather be honest about the edges than pad a list."
    >
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {skillGroups.map((group, index) => (
          <Reveal key={group.title} delay={index * 0.06}>
            <div className="glass leaf h-full p-6 sm:p-7">
              <p className="text-display text-[1.1rem] text-porcelain">{group.title}</p>
              <ul className="mt-4 space-y-2.5">
                {group.items.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[0.95rem] text-mist">
                    <span
                      aria-hidden="true"
                      className="h-1.5 w-1.5 rotate-45 bg-gradient-to-br from-blush to-orchid"
                    />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </div>
    </Section>
  );
}
